module.exports = __webpack_public_path__ + "static/media/niacinsr1.e613ed36.pdf";